import * as Yup from "yup";

const Validation = Yup.object({
  title: Yup.string().required("Please enter title!"),
  description: Yup.string().required("Please enter description!"),
});

export default Validation;
